import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "col-md-8 p-sm-5 p-3" };
const _hoisted_2 = {
    key: 0,
    class: "registerContent"
};
const _hoisted_3 = { class: "mb-sm-5 mb-3" };
const _hoisted_4 = { class: "fc-brand_deep_blue strong" };
const _hoisted_5 = { class: "mb-3" };
const _hoisted_6 = {
    class: "strong",
    style: { "word-break": "break-all" }
};
const _hoisted_7 = { class: "mb-sm-5 mb-3" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col-lg-6" };
const _hoisted_10 = { class: "col-lg-6" };
const _hoisted_11 = {
    key: 1,
    class: "successContent mt-3",
    style: { "min-height": "300px" }
};
const _hoisted_12 = {
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    title: "",
    class: "strong font7",
    "data-original-title": "myPOINTS werden Dir gutgeschrieben und können gegen Gutscheine eingetauscht werden"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_base_password_input = _resolveComponent("base-password-input");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _cache[22] || (_cache[22] = _createElementVNode("div", {
            class: "illustrationUserAccountBase col-md-4",
            style: { "background-image": "url('/images/checkout/checkoutSuccessDesktop.png')", "background-size": "cover" }
        }, [
            _createElementVNode("img", {
                alt: "Vielen Dank für Deinen Kauf",
                class: "illustrationUserAccountMobile",
                src: "/images/checkout/checkoutSuccessMobile.png",
                style: { "width": "100%", "display": "none" }
            })
        ], -1)),
        _createElementVNode("div", _hoisted_1, [
            (!_ctx.isLogin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "h3-responsive" }, "Nur ein Schritt zu Deinem Nutzerkonto", -1)),
                    _cache[11] || (_cache[11] = _createElementVNode("p", null, "Gib ein Passwort ein, um Deine Vorteile nicht zu verlieren:", -1)),
                    _createElementVNode("ul", _hoisted_3, [
                        _createElementVNode("li", null, [
                            _cache[4] || (_cache[4] = _createTextVNode(" Sammle ", -1)),
                            _createElementVNode("span", _hoisted_4, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.bonus_points), 1),
                                _cache[2] || (_cache[2] = _createTextVNode(" myPOINTS ", -1)),
                                _cache[3] || (_cache[3] = _createElementVNode("span", {
                                    "data-toggle": "tooltip",
                                    "data-placement": "bottom",
                                    title: "myPOINTS werden Dir mit der Auszahlung gutgeschrieben und können gegen Gutscheine eingetauscht werden",
                                    class: "strong font7 pointerhover"
                                }, [
                                    _createElementVNode("i", { class: "icon-ankaufbedingungen" })
                                ], -1))
                            ]),
                            _cache[5] || (_cache[5] = _createTextVNode(" , die Du mit dieser Bestellung verdient hast ", -1))
                        ]),
                        _cache[6] || (_cache[6] = _createElementVNode("li", null, "Schnelleres Abschließen von Bestellungen", -1)),
                        _cache[7] || (_cache[7] = _createElementVNode("li", null, "Überprüfung des Status Deiner Bestellungen", -1)),
                        _cache[8] || (_cache[8] = _createElementVNode("li", null, "Exklusive Gutscheincodes", -1))
                    ]),
                    _createElementVNode("p", _hoisted_5, [
                        _cache[9] || (_cache[9] = _createTextVNode(" Dein Konto wird für die folgende E-Mail Adresse erstellt: ", -1)),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.customer_email), 1)
                    ]),
                    _createElementVNode("form", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_base_password_input, {
                                    id: "passwordInputField",
                                    name: "password",
                                    title: "Wähle Dein Passwort",
                                    modelValue: _ctx.password,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.password) = $event)),
                                    placeholder: "Wähle Dein Passwort"
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["buttonBase buttonGreen w-100 font6-responsive", _ctx.button_shake ? 'nope-shake' : '']),
                                    style: { "min-height": "48px" },
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.submitPassword && _ctx.submitPassword(...args)))
                                }, " Nutzerkonto erstellen ", 2)
                            ])
                        ])
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("p", { class: "font8-responsive fc-gray1" }, [
                        _createTextVNode(" Mit der Registrierung erklärst du dich mit den "),
                        _createElementVNode("a", {
                            href: "/agb",
                            target: "_blank",
                            title: "Allgemeinen Geschäftsbedingungen",
                            class: "link-in-text"
                        }, "AGB"),
                        _createTextVNode(" und "),
                        _createElementVNode("a", {
                            href: "/datenschutz",
                            target: "_blank",
                            title: "Datenschutz von mySWOOOP",
                            class: "link-in-text"
                        }, " Datenschutzbestimmungen "),
                        _createTextVNode(" der "),
                        _createElementVNode("span", { class: "d-inline-block" }, "mySWOOOP"),
                        _createTextVNode(" GmbH einverstanden. ")
                    ], -1))
                ]))
                : _createCommentVNode("", true),
            (_ctx.isLogin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "h3-responsive" }, [
                        _createTextVNode(" Willkommen bei "),
                        _createElementVNode("span", { class: "d-inline-block" }, "mySWOOOP"),
                        _createTextVNode(" ! ")
                    ], -1)),
                    _createElementVNode("p", null, [
                        _cache[14] || (_cache[14] = _createTextVNode(" Wir haben Dir ", -1)),
                        _createElementVNode("span", _hoisted_12, [
                            _createTextVNode(_toDisplayString(_ctx.bonus_points) + " myPOINTS ", 1),
                            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "icon-ankaufbedingungen" }, null, -1))
                        ]),
                        _cache[15] || (_cache[15] = _createTextVNode(" in Deinem Nutzerkonto hinterlegt. ", -1)),
                        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                        _cache[17] || (_cache[17] = _createTextVNode(" Du verpasst ab sofort keine Deals und Aktionen mehr. ", -1))
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("a", {
                        href: "/mein-account",
                        class: "mb-sm-5 fc-green strong text-underline d-block"
                    }, "ZU MEINEM PROFIL", -1)),
                    _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("a", {
                        href: "/mein-account/transactions/purchases",
                        class: "buttonGreen buttonBase d-inline-block"
                    }, " Status meiner Bestellung ", -1))
                ]))
                : _createCommentVNode("", true)
        ])
    ], 64));
}
